var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIdCarSummer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 39843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39842"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 328",
    width: 48,
    height: 48,
    rx: 10,
    fill: "#6260A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0192 30.9258H25.1794V25.222H30.9175V23.0618H25.1794V17.0832H23.0192V23.0618H17.075V25.222H23.0192V30.9258ZM24.0065 37.9539C22.0777 37.9539 20.2676 37.5887 18.5762 36.8585C16.8848 36.1283 15.4055 35.1296 14.1383 33.8624C12.8712 32.5952 11.8724 31.1154 11.1422 29.423C10.412 27.7307 10.0469 25.9192 10.0469 23.9884C10.0469 22.0577 10.412 20.2458 11.1422 18.5527C11.8724 16.8596 12.8707 15.385 14.137 14.129C15.4034 12.873 16.8829 11.8786 18.5757 11.1459C20.2685 10.4132 22.0804 10.0469 24.0116 10.0469C25.9428 10.0469 27.7553 10.413 29.449 11.1453C31.1428 11.8775 32.6175 12.8713 33.8731 14.1266C35.1287 15.3819 36.1227 16.8581 36.8552 18.555C37.5876 20.252 37.9539 22.0655 37.9539 23.9953C37.9539 25.9249 37.5875 27.7353 36.8548 29.4266C36.1221 31.1179 35.1278 32.5947 33.8718 33.857C32.6157 35.1194 31.1397 36.1177 29.4437 36.8522C27.7477 37.5866 25.9353 37.9539 24.0065 37.9539ZM24.0134 35.6129C27.2328 35.6129 29.9695 34.4819 32.2236 32.2198C34.4776 29.9577 35.6047 27.2136 35.6047 23.9873C35.6047 20.7679 34.4798 18.0312 32.23 15.7771C29.9802 13.5231 27.2343 12.3961 23.9921 12.3961C20.7815 12.3961 18.0447 13.5209 15.782 15.7707C13.5192 18.0205 12.3878 20.7665 12.3878 24.0086C12.3878 27.2193 13.5189 29.956 15.7809 32.2187C18.043 34.4815 20.7872 35.6129 24.0134 35.6129Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIdCarSummer);
export default __webpack_public_path__ + "static/media/add_id_car_summer.16a83391f8fd2cc9baad3c17ddd3e17b.svg";
export { ForwardRef as ReactComponent };